import { Check } from '@mui/icons-material';
import { Box, Button, Container, Paper } from '@mui/material';
import { Subheader } from 'components';
import CostItemForm from './CostItemForm';
import { useNavigate, useParams } from 'react-router-dom';
import useCostItems from 'hooks/useCostItems';
import { useEffect } from 'react';
import { useAlerts } from 'hooks';

const CostItemEdit = () => {
	const navigate = useNavigate();
	const { id } = useParams();

	const { findCostItem, costItem, isLoading, handleChange, updateCostItem } =
		useCostItems();
	const { showAlertSuccess, showAlertError } = useAlerts();

	const handleSaveClick = async () => {
		if (costItem?.name.length > 3 && costItem?.cost > 0) {
			await updateCostItem(costItem);
			showAlertSuccess('Cost item has been updated');
			return navigate(`/cost-items/${id}`, { replace: true });
		}

		showAlertError(
			'Failed to update cost item. Please check the form for errors.'
		);
	};

	useEffect(() => {
		if (id) findCostItem(id);
	}, [id]);

	return (
		<>
			<Subheader
				title="Edit Cost Item"
				buttons={[
					<Button
						color="primary"
						variant="contained"
						startIcon={<Check />}
						onClick={handleSaveClick}
					>
						Save
					</Button>
				]}
			/>

			<Container>
				<Paper>
					<Box p={4}>
						<CostItemForm costItem={costItem} handleChange={handleChange} />
						<Box py={2}>
							<Button
								color="primary"
								variant="contained"
								startIcon={<Check />}
								onClick={handleSaveClick}
							>
								Save
							</Button>
						</Box>
					</Box>
				</Paper>
			</Container>
		</>
	);
};

export default CostItemEdit;
